// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '팜젠사이언스',
  targetSheetName: '용역표(26.6)',
  headerRowIndex: 61,
  headerRowCount: 1,
  dataStartRowIndex: 62,
  repeatedHeaderRowAction: 'skip',
  columnMapping: {
    drugCode: 'EDI청구코드',
    drugName: '제품명 ▼',
    price: '약가',
    commissionRate: '수수료율',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'No.',
    '제품명 ▼',
    'EDI청구코드',
    '대조약',
    '성분 및 함량',
    '약가',
    '수수료율',
    '수수료액',
    '비고',
  ],
});
